import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

class Loader extends Component {

    render() {
        let loaders = [];
        if(this.props.Loaders.overlay){
            for (let i=0; i<this.props.Loaders._numberOfLoaders; i++) {
                loaders.push(<div key={`loader${i}`} className="loader"></div>);
            }
        }
        return (
            <div id="loadersContainer">{ loaders }</div>
        );
    }
}
Loader.propTypes = {
    Loaders: PropTypes.object
};
Loader.defaultProps = {
    Loaders: {overlay: true, _numberOfLoaders: 0}
};

const mapStateToProps = (state) => {
    return {
        Loaders: state.Loaders
    }
};

export default connect(mapStateToProps, null)(Loader);